<template>
  <div>
    <!-- start -->
    <!-- end -->
  </div>
</template>

<script>
import { onConnect, onbindAccount } from "@/utils/websocket/cim.web.sdk.js";
// import Push from "push.js";
import { enums } from "@/utils/websocket/actionEnums";
import Cookies from "js-cookie";
import db from "@/utils/localstorage";

export default {
  name: "Websocket",
  computed: {},
  data() {
    // 数据
    return {};
  },
  mounted() {
    var token = undefined;
    var userInfo = undefined;
    if (Cookies.get("JobseekerAuthorization")) {
      userInfo = db.get("JobseekerInfo");
      token = Cookies.get("JobseekerAuthorization");
    }
    if (Cookies.get("CompanyAuthorization")) {
      userInfo = db.get("enterpriseInfo").info;
      token = Cookies.get("CompanyAuthorization");
    }
    if ((token, userInfo)) {
      // console.log(token, "token");
      // 挂载
      this.getlist(token, userInfo);
      window.onMessageReceived = this.onMessageReceived;
      window.onReplyReceived = this.onReplyReceived;
      window.onConnectFinished = this.onConnectFinished();
    }
  },
  methods: {
    // 方法
    getlist(token, userInfo) {
      onConnect(token, userInfo); // 初始化
    },
    onConnectFinished() {
      // 登陆
      onbindAccount();
    },
    onReplyReceived(reply) {
      // 上线响应
      if (reply.key === "client_bind" && reply.code === "200") {
        console.log("上线响应");
      }
      // 首次连接获取通知条数
      if (reply.key === "MESSAGE_COUNT" && reply.code === "200") {
        var message = JSON.parse(reply.message);
        // eventBus 传输
        this.event.$emit("MESSAGE_COUNT", message.messageCount);
        // 获取Im未读消息条数
        this.event.$emit("IM_MESSAGE_COUNT", message.ImMessageCount);
      }
    },
    onMessageReceived(message) {
      // 收消息
      // console.log(message, "message");

      // 账号在其他设备登陆
      if (message.action === enums.actions.ACTION_999) {
        // this.Logout().then(() =>
        //     location.href = '/index'
        // )
        return false;
      }
      // 系统通知
      if (message.action === enums.actions.ACTION_0) {
        // 推送到浏览器消息通知
        var content = JSON.parse(message.content);
        // this.pushMessage(message.title, content.msg);
        this.$notification.open({
          message: message.title,
          description: content.msg,
          icon: <a-icon type="notification" style="color: #1890FF" />,
          duration: 5,
          btn: (h) => {
            return h(
              "a-button",
              {
                props: {
                  type: "primary",
                  size: "small",
                },
                on: {
                  click: async () => {
                    // doSomeThing
                    console.log("点击确认");
                  },
                },
              },
              "确认"
            );
          },
          // 关闭
          onClose: () => { },
        });
      }

      if (message.action === enums.actions.ACTION_1) {
        // 推送到浏览器消息通知
        var content = JSON.parse(message.content);
        // eventBus 传输
        this.event.$emit("MESSAGE_COUNT", content);
      }

      if (message.action === enums.actions.ACTION_2) {
        // 求职者发送消息到企业
        console.log("求职者发送消息到企业：", message);

        this.$bus.$emit("showonwer", message)
      }

      if (message.action === enums.actions.ACTION_3) {
        // 企业发送消息到求职者
        console.log("企业发送消息到求职者", message);
        this.$bus.$emit("showfirm", message)
      }


      if (message.action === enums.actions.ACTION_4) {
        // 接收IM消息提醒条数和和某个id的最后一条聊天记录
        var content = JSON.parse(message.content);
        this.event.$emit("IM_MESSAGE_COUNT", content.ImMessageCount)
        console.log(content,'contentcontent147');
        if (content.lastMessage) {
          this.event.$emit("IM_LAST_MESSAGE", content.lastMessage)
          console.log(content.lastMessage,'sdadasdsa');
        }
      }

      return;
    },

    //推送弹框消息
    // pushMessage(title, message) {
    //   Push.create(title, {
    //     body: message,
    //     requireInteraction: true,
    //     //icon: '/icon.png',
    //     timeout: 600000,
    //   });
    // },
    // doSomeThing
    doSomeThing() {
      console.log(1);
    },
  },
};
</script>

<style lang="less" scoped></style>
